export const TEST_TYPES = [
  'homepage',
  'research',
  'survey',
  'interview',
  'prototype',
  'sell',
];

/* eslint-disable import/no-mutable-exports */
const testTypeOptions = {};

export function loadTestTypes(locales) {
  TEST_TYPES.forEach((sectionName) => {
    const foundTab = locales.testing.chooseTest.tabs.find(
      (tab) => tab.sectionName === sectionName,
    );
    if (foundTab) {
      testTypeOptions[sectionName] = foundTab.name;
    }
  });
}

export { testTypeOptions };
export default testTypeOptions;
